// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { withStyles } from "tss-react/mui";
import cx from 'classnames';

import Message from '@shared/components/Message';
import { ButtonProps } from '@shared/components/Button';
import DroneIcon from '@shared/icons/Drone';

export interface ErrorHandlerProps {
  className?: string;
  heading?: React.ReactNode;
  buttonProps?: Partial<ButtonProps>;
}

const handleReloadApp = () => {
  // window.location.reload(true);
  window.location.reload();
};

class ErrorHandler extends React.Component<ErrorHandlerProps> {
  static defaultProps = {
    heading: 'Something went wrong',
    buttonProps: {
      text: 'Reload application',
      onClick: handleReloadApp
    }
  };

  render() {
    const { heading, buttonProps } = this.props;
    const classes = withStyles.getClasses(this.props);

    return (
      <Message
        classes={{
          root: classes.globalErrorRoot,
        }}
        icon={<DroneIcon variant="raw" className={cx(classes.droneIcon, classes.droneCrashAnimation)} />}
        heading={heading}
        buttonProps={{
          size: 'small',
          ...buttonProps
        }}
      />
    );
  }
}

const initialDroneIconPosition = 'translateY(-10vh)';

const ErrorHandlerStyled = withStyles(
  ErrorHandler, 
  (theme, props) => ({
    "root": {},
    "droneIcon": {},
    "droneCrashAnimation": {
      animationFillMode: 'forwards',
      animationName: '$crash',
      animationDuration: '3.3s',
      animationTimingFunction: 'ease-in'
    },
    "globalErrorRoot": {
      height: '80vh',
      
      '& svg': {
        fill: theme.palette.colors.black,
        opacity: 1
      }
    },
  
    '@keyframes crash': {
      from: { 
        transform: initialDroneIconPosition,
      },
      '10%': {
        transform: 'translate(-2px, -7vh) rotate(15deg)', 
      },
      '20%': {
        transform: 'translate(3px, -9vh) rotate(25deg)',
      },
      '30%': {
        transform: 'translate(1px, -8vh) rotate(-5deg)',
      },
      '40%': { 
        transform: `translate(-4px, -10vh) rotate(-1deg)`, 
      },
      '50%': {
        transform: 'translate(-1px, -7vh) rotate(5deg)',
      },  
      '55%': {
        transform: 'translate(0px, -10vh) translate3d(0, 0, 0) rotate(-15deg)',
      },
      '70%': { 
        transform: 'translate(-30px, 3.1vh) rotate(-172deg)',
      } ,
      to: {
        transform: 'translate(-30px, 3.1vh) rotate(-172deg)',
      }   
    }
  })
);

export default ErrorHandlerStyled;